import { motion } from "framer-motion";

// Small uppercase tracked section label with a leading index + rule.
export default function SectionLabel({ index, children, className = "" }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 12 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
      className={`flex items-center gap-4 label text-white/50 ${className}`}
    >
      {index && <span className="text-lav-400">{index}</span>}
      <span className="h-px w-8 bg-white/20" />
      <span>{children}</span>
    </motion.div>
  );
}
